// extracted by mini-css-extract-plugin
module.exports = {"content":"light_content__0b_Fy"};